/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          :  UserVerification.tsx
*
* Project Title :  Checkout
*
* Description	:
*
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : Avanthi G(E860178)
*
* @Date			: Aug 30, 2019
*
* @Version      : Version 1.0
*
* By            : Avanthi G (E860178)
* On            : Aug 30, 2019
* Description   : ASDS-1082:Updated code to display CheckOut routing URL in browser

* By            : Archana P (E542450)
* On            : Sep 13 , 2019
* Description   : ASDS-1079: Updating code to navigate to Purchase Software page when SoldTo/ShipTo is selected
 *
 * * By            :SIVATEJA.P (H267743)
 * On            : Sep 27 , 2019
 * Description   : ASDS-1290: fixed the select account issue in shipping and billig
 *                 (added accountId in shipTo & soldTo variables)
 *
 * By            : H175591
* On            : 08 Nov 2019
* Description   : ASDS-1677
*
* By            : SandeepRaja
* On            : Nov 7, 2019
* Description   : ASDS-1679: Error handling
 *
 *  By            : sivateja
 * On            : Nov 8, 2019
 * Description   : ASDS-167: fixed the select account logic
 *
 *
 * By            : Deepthi Bachu - E844276
 * On            : 02 DEC, 2019
 * Description   : ASDS-1961 - Undefined customer name in Review order page when user has previously selected address
 *
 * By            : Deepthi Bachu - E844276
 * On            : 04 Dec, 2019
 * Description   : ASDS-1961 -  loader while redirecting from ASDS dash board to checkout
 *
 * By            : Madhu Gali
 * On            :  Dec 18, 2019
 * Description   : ASDS-584
 *
 * By            : Madhu Gali - H175591
 * On            : Jan 10, 2019
 * Description   : ASDS-2152
 *
 * By            : H224423
 * On            : Feb 13 2019
 * Description   : ASDS-2270 - Previously selected address is not set properly when the user login for the second time.
 *
* By            : Madhu Gali - H175591
* On            : Feb 19, 2020
* Description   : ASDS-2355
*
* By            : Madhu Gali - H175591
* On            : Feb 27, 2020
* Description   : ASDS-2356 CheckOut Forge QA Environment validation
*
* By            : Deepthi Bachu - E844276
* On            : 04 Mar, 2020
* Description   : ASDS-2409 - NGBSS place order service - address parameter changes
*
* By            : Deepthi Bachu - E844276
* On            : 12 Mar, 2020
* Description   : Integration issue fixes
*
* By            : E807958
* On            : Mar 30, 2020
* Description   : ASDS-1763
*
* By            : H422337
* On            : Oct 19, 2020
* Description   : ASDS-3199 - Customer Account Dropdown
*
* By            : H422335
* On            : Oct 27, 2020
* Description   : ASDS-3269 Migration of backend URLs to Forge endpoints
******************************************************************************/

import * as React from 'react';
import { UserSessionInf, constructUserSessionObj, isValueUndefined, getProperty } from '../utils/util';
import UserValidationAction from './checkout/redux/actions/userDetailsActions';
import RouteConstants from './checkout/constants/route-constants';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {  CheckoutServiceURL } from './checkout/constants/checkout-constants';
import { SelectAccountInfo, SaveAccountInfo, SaveAddressUserReqObjType } from './checkout/utils/checkout-interfaces';
import { Grid, Icon } from '@scuf/common';
import BannerComponent from './checkout/BannerComponent/bannerComponent'
import SelectAccountActions from './checkout/redux/actions/select-account-actions';
import { logInfo } from '../utils/console-utility';
import GenericLoader from './checkout/Loader/Loader';
import AddressDetails from './checkout/API/select-account-api';

interface UserVerificationStateI {
    firsttimeuser_selectAccount: boolean,
}

class UserVerification extends React.Component<any, UserVerificationStateI> {

    constructor(props: any) {
        super(props);
        this.showSelectAccount = this.showSelectAccount.bind(this);
        this.state = {
            firsttimeuser_selectAccount: false,
        };
    }

    async componentDidMount() {
        try {
            const userSessionInfo = this.props.userValidationData.payload.userSessionInfo;
            let liveUserSessionObjTemp = {};
            if (userSessionInfo && userSessionInfo.isForgeEnv) {
                const accessTokenObj = userSessionInfo.accessToken;

                liveUserSessionObjTemp['access_token'] = accessTokenObj.access_token;
                liveUserSessionObjTemp['token_type'] = accessTokenObj.token_type;
                liveUserSessionObjTemp['expires_in'] = accessTokenObj.expires_in;
                liveUserSessionObjTemp['id_token'] = accessTokenObj.id_token;
                liveUserSessionObjTemp['refresh_token'] = accessTokenObj.refresh_token;
            }

            let liveUserSessionObj: UserSessionInf = constructUserSessionObj(liveUserSessionObjTemp);

            // Retrieving checkout user session information from browsers local storage.
            // let localStoreSessionObj: any = localStorage.getItem('checkoutInLocalStorage'); //APU Phase 3 - Pen testing fix - To remove access token from local storage
            //    let localStorageValuesObj: any;
            // if (localStoreSessionObj != null) {
            //     let jsonStr = JSON.parse(localStoreSessionObj);
            //     localStorageValuesObj = constructUserSessionObj(jsonStr);
            //     logInfo('local storage values object', localStorageValuesObj);
            // }
            let sessionStoreSessionObj: any = sessionStorage.getItem('checkoutInLocalStorage');
            let sessionStorageValuesObj: any;
            if (sessionStoreSessionObj != null) {
                let jsonStr = JSON.parse(sessionStoreSessionObj);
                sessionStorageValuesObj = constructUserSessionObj(jsonStr);
                logInfo('local storage values object', sessionStorageValuesObj);
            }

            // if (!isValueUndefined(liveUserSessionObj) || !isValueUndefined(localStorageValuesObj)) { //APU Phase 3 - Pen testing fix - To remove access token from local storage
            if (!isValueUndefined(liveUserSessionObj) || !isValueUndefined(sessionStorageValuesObj)) {
                let userSessionObj: any;

                if (!isValueUndefined(liveUserSessionObj)) {
                    userSessionObj = liveUserSessionObj;
                // } else if (!isValueUndefined(localStorageValuesObj)) { //APU Phase 3 - Pen testing fix - To remove access token from local storage
                // userSessionObj = localStorageValuesObj;
                } else if (!isValueUndefined(sessionStorageValuesObj)) {
                    userSessionObj = sessionStorageValuesObj;
                }

                await this.props.getUserInformation();
                let user = this.props.userValidationData.payload.userInfo;
                logInfo('userLoggedInData ', user);

                if (!user) { // Error in receiving response from CWA.
                    logInfo('Kick the user to myaerospace home page.');
                    //localStorage.removeItem('checkoutInLocalStorage'); //APU Phase 3 - Pen testing fix - To remove access token from local storage

                    sessionStorage.removeItem('checkoutInLocalStorage');
                } else { // Received a valid response from CWA
                    //  if (isValueUndefined(localStorageValuesObj)    //APU Phase 3 - Pen testing fix - To remove access token from local storage
                    //     || isValueUndefined(localStorageValuesObj['customer_sub'])
                    //     || (localStorageValuesObj['customer_sub'] === user.customer_sub)) {
                    if (isValueUndefined(sessionStorageValuesObj)
                        || isValueUndefined(sessionStorageValuesObj['customer_sub'])
                        || (sessionStorageValuesObj['customer_sub'] === user.customer_sub)) {
                        userSessionObj['customer_sub'] = user.customer_sub;
                        logInfo('updated liveUserSessionObj', userSessionObj);

                        const jsonStr = JSON.stringify(userSessionObj);
                        logInfo('browser hash values response', jsonStr);
                        // Storing the query parameters to the browsers local store.
                        //localStorage.setItem('checkoutInLocalStorage', jsonStr);  //APU Phase 3 - Pen testing fix - To remove access token from local storage
                        sessionStorage.setItem('checkoutInLocalStorage', jsonStr);

                        const userID = userSessionObj['customer_sub'];
                        await this.props.checkASDSAccess(userID);
                        const asdsAccess: boolean = this.props.userValidationData.payload.asdsAccess;

                        await this.props.checkUserRole();

                        if (asdsAccess) {
                            this.checkFirstTimeUser(userID);
                        } else {

                            window.location.assign(getProperty(CheckoutServiceURL.ASDS_ROLE_ACCESS_URL));
                        }
                    } else {
                        // logInfo('Invalid user identified: logged in ', user.customer_sub, ' but session already created for ', localStorageValuesObj['customer_sub']);
                        logInfo('Invalid user identified: logged in ', user.customer_sub, ' but session already created for ', sessionStorageValuesObj['customer_sub']);
                        // The user should be navigated to Joule landing page.
                        logInfo('Kick the user to myaerospace home page.');
                        // localStorage.removeItem('checkoutInLocalStorage'); //APU Phase 3 - Pen testing fix - To remove access token from local storage
                        sessionStorage.removeItem('checkoutInLocalStorage');
                    }
                }
            } else {
                // The user should be navigated to Joule landing page.
                logInfo('Kick the user to myaerospace home page.');
                // localStorage.removeItem('checkoutInLocalStorage'); //APU Phase 3 - Pen testing fix - To remove access token from local storage
                sessionStorage.removeItem('checkoutInLocalStorage');
            }
        } catch (error) {
            this.props.history.push(RouteConstants.ERROR_PAGE);
        }
    }

    showSelectAccount() {
        this.props.history.push(RouteConstants.USER_VERIFICATION_SELECT_ACCOUNT);
    }

    async checkFirstTimeUser(userID: string) {
        try {
            await this.props.checkSFDCCaseStatus(userID);
            if (this.props.userValidationData.payload.userAddrDetails && this.props.userValidationData.payload.userAddrDetails.results) {
                let userRole = this.props.userValidationData.payload.isAdminUser;
                logInfo('userRole ', userRole);

                if (userRole) {  // Admin, show Select Account
                    this.showSelectAccount();
                }
                else {          // if user, Check SFDC CASE Status

                    let userAddr_Account = this.props.userValidationData.payload.userAddrDetails.results.account;
                    let sapSoldToLength = 0;
                    let sapShipToLength = 0;

                    if (!isValueUndefined(userAddr_Account)) {
                        let userAddr = userAddr_Account.accounts;
                        userAddr.map((e: any) => {
                            // Finding SoldTo, ShipTo array size
                            if (e.sapSoldTo) {
                                sapSoldToLength = sapSoldToLength + Object.keys(e.sapSoldTo).length;
                            }
                            if (e.sapShipTo) {
                                sapShipToLength = sapShipToLength + Object.keys(e.sapShipTo).length;
                            }
                        });
                    }
                    // FirstTimeUser
                    if (sapSoldToLength === 0 && sapShipToLength === 0) {
                        let caseDetails = this.props.userValidationData.payload.userAddrDetails.results.caseDetails;
                        logInfo('caseDetails', caseDetails);

                        // Below commented code will be removed after SIT.
                        // If first time user and no SFDC case show 'Request to new aaddress'
                        // if (caseDetails === "" || caseDetails === null || typeof (caseDetails) === "undefined" || Object.entries(caseDetails).length === 0) {
                        //     this.props.history.push(RouteConstants.NEW_ADDRESS);
                        // }
                        // else {
                        //     let sfdcStatus = caseDetails.caseStatus;
                        //     let sfdcCaseNo = caseDetails.caseNumber;
                        //     logInfo("sfdcStatus", sfdcStatus);
                        //     const alertDesc = CheckoutUILabels.ALERT_PENDING_DESC + sfdcCaseNo + CheckoutUILabels.ALERT_PENDING_DESC1;
                        //     //If first time user and SFDC Case is in pending, show SFDC Case Pending alert
                        //     if (sfdcStatus.toUpperCase() === "OPEN" || sfdcStatus.toUpperCase() === "PENDING") {
                        //         this.props.history.push(
                        //             {
                        //                 pathname: '/request-status',
                        //                 state: {
                        //                     AlertHeader: CheckoutUILabels.ALERT_PENDING_HEADER,
                        //                     AlertMsg: CheckoutUILabels.ALERT_PENDING_MSG,
                        //                     AlertDescription: alertDesc,
                        //                     redirectURL: getProperty(CheckoutServiceURL.ADS_DASHBOARD_URL),// Pending - remove sessionStorage and LocalStorage values
                        //                 }
                        //             }
                        //         );
                        //     }
                        //     //If first time user and case is in closed state, show select Account
                        //     else {
                        //         this.showSelectAccount();
                        //     }
                        // }
                        if (!caseDetails.length) {
                            logInfo('No case details, hence redirecting the user to new address screen');
                            this.props.history.push(RouteConstants.NEW_ADDRESS);
                        } else {
                            const sfdcCaseNo = caseDetails.filter(ele => 'Closed'.toUpperCase() !== ele.status.toUpperCase())
                                .map(ele1 => ele1.caseNumber).join(', ');

                            logInfo('sfdcCaseNo ', sfdcCaseNo);

                            const redirect = RouteConstants.REQUEST_STATUS + '/' + sfdcCaseNo;
                            this.props.history.push(redirect);
                        }
                    }
                    // If not first time user and have prev selected addresses, show Purchase Software
                    else {
                        // If user has single address.
                        const userValidationDataObj = this.props.userValidationData.payload;
                        if (sapSoldToLength && sapShipToLength && userValidationDataObj) {
                            const { userInfo, userAddrDetails } = userValidationDataObj;
                            const { results: { prevSelectedAddress } } = userAddrDetails;
                            const { results: { account: { accounts } } } = userAddrDetails;
                            // Display purchase software only if matches bellow conditions...Do not hard code index value for accounts processing.
                            if (prevSelectedAddress
                                && prevSelectedAddress.soldTo
                                && prevSelectedAddress.shipTo
                                && accounts[0].sapShipTo
                                && accounts[0].sapShipTo instanceof Array
                                && accounts[0].sapSoldTo
                                && accounts[0].sapSoldTo instanceof Array
                            ) {
                                const userObj = {
                                    userId: userInfo.customer_sub,
                                    sapSoldTo: prevSelectedAddress.soldTo,
                                    sapShipTo: prevSelectedAddress.shipTo,
                                    soldToAddressId: prevSelectedAddress.soldToId,
                                    shipToAddressId: prevSelectedAddress.shipToId,
                                };

                                let previouselySelectedAccount: any = undefined;
                                accounts.forEach((account) => {
                                    let sapshipToArr = account.sapShipTo.filter((shipToObj) => {
                                        return shipToObj.sapNumber === prevSelectedAddress.shipTo;
                                    });
                                    if (sapshipToArr.length > 0) {
                                        previouselySelectedAccount = account;
                                    }
                                });
                                if (previouselySelectedAccount && previouselySelectedAccount.sapShipTo && previouselySelectedAccount.sapSoldTo) {
                                    let selectedShipTo = previouselySelectedAccount.sapShipTo.filter(shipTo => shipTo.sapNumber === userObj.sapShipTo);
                                    if (selectedShipTo && selectedShipTo.length > 0) {
                                        selectedShipTo[0].accountId = previouselySelectedAccount.accountId;
                                        selectedShipTo[0].customerName = previouselySelectedAccount.customerName;
                                    }
                                    let selectedSoldTo = previouselySelectedAccount.sapSoldTo.filter(soldTo => soldTo.sapNumber === userObj.sapSoldTo);
                                    if (selectedSoldTo && selectedSoldTo.length > 0) {
                                        selectedSoldTo[0].accountId = previouselySelectedAccount.accountId;
                                        selectedSoldTo[0].customerName = previouselySelectedAccount.customerName;
                                    }
                                    const selectAccount: SelectAccountInfo = {
                                        customerName: previouselySelectedAccount.customerName,
                                        customerId: previouselySelectedAccount.accountId,
                                        accountId: previouselySelectedAccount.accountId,
                                        shipTo: selectedShipTo.length > 0 ? selectedShipTo[0] : '',
                                        soldTo: selectedSoldTo.length > 0 ? selectedSoldTo[0] : '',
                                    };
                                    this.props.setSelectAccount(selectAccount, userObj); // Set to selectAccount state(redux).
                                    this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
                                } else {
                                    // Case for not containing previous selected address show select Account. NOT GOOD .. SOME THING WENT WRONG
                                    this.showSelectAccount();
                                }
                            } else if (!prevSelectedAddress && sapSoldToLength === 1 && sapShipToLength === 1) {
                                const selectAccount: SelectAccountInfo = {
                                    customerName: accounts[0].customerName,
                                    customerId: accounts[0].accountId,
                                    accountId: accounts[0].accountId,
                                    shipTo: accounts[0].sapShipTo[0],
                                    soldTo: accounts[0].sapSoldTo[0],
                                };

                                const userObj: SaveAccountInfo = {
                                    userId: userInfo.customer_sub,
                                    sapSoldTo: selectAccount.soldTo.sapNumber,
                                    sapShipTo: selectAccount.shipTo.sapNumber,
                                    soldToAddressId: selectAccount.soldTo.addressId,
                                    shipToAddressId: selectAccount.shipTo.addressId
                                };

                                this.props.setSelectAccount(selectAccount, userObj); // Set to selectAccount state(redux).

                                const saveAddressUserRequestObj: SaveAddressUserReqObjType = {
                                    defaultAddresses: []
                                };
                                saveAddressUserRequestObj.defaultAddresses.push(userObj);
                                AddressDetails.saveSelectedAddressDetails(userInfo.customer_sub, saveAddressUserRequestObj);
                                this.props.history.push(RouteConstants.PURCHASE_SOFTWARE);
                            }
                            else {
                                // Case for not containing previous selected address show select Account.
                                this.showSelectAccount();
                            }
                        } else {
                            this.showSelectAccount();
                        }
                    }
                }
            } else {
                this.props.history.push(RouteConstants.ERROR_PAGE);
            }
        } catch (error) {
            this.props.history.push(RouteConstants.ERROR_PAGE);
        }
    }

    render() {
        return (
            <StaticContent />
        );
    }
}

export function StaticContent() {
    return (
        <div>
            <Grid className="fullwidthRow">
                {/****************Hero banner starts here****************/}
                <Grid.Row className="fullwidthRow">
                    <Grid.Column width={12} className="fullwidthRow" >
                        <BannerComponent />
                    </Grid.Column>
                </Grid.Row>
                {/****************secondary nav  starts here****************/}
                <Grid.Row>
                    <Grid.Column width={12} className="fullwidthRow">
                        <div className="secondaryNav">
                            <Grid>
                                <Grid.Row>
                                    <Grid.Column width={3}>
                                        <div className={`cust-drop-down-font customer-name`}>
                                            Customer Account
                                        &nbsp;
                                        <Icon name="caret-down" size="medium" />
                                        </div>
                                    </Grid.Column>
                                    <Grid.Column width={3}>
                                        {/* Enable after implememtimg
                                        <a href="#">My Purchased Softwares</a>*/}
                                    </Grid.Column>
                                    <Grid.Column width={1}>
                                    </Grid.Column>
                                </Grid.Row>
                            </Grid>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <GenericLoader text="Processing your request" className="products-loader" loading={true} overlayColor="rgb(247, 247, 247)" />
        </div>
    );
}

function mapStateToProps(state) {
    return {
        userValidationData: state.userValidationData,
    };
}

export default connect(mapStateToProps,
                       {
                            getUserInformation: UserValidationAction.getLoggedInForgeUserInfo,
                            checkSFDCCaseStatus: UserValidationAction.checkSFDCCaseStatus,
                            setSelectAccount: SelectAccountActions.setSelectAccount,
                            checkASDSAccess: UserValidationAction.checkASDSAccess,
                            checkUserRole: UserValidationAction.checkUserRole
                        }
)(withRouter(UserVerification));